export const MODULE_IDS = {
  INVENTORY: 'inventory',
  KIT_CHECKOFF: 'kit-checkoff',
  KITS: 'kits',
  MAINTENANCE: 'maintenance',
  PERSONNEL: 'personnel',
  SCHEDULING: 'scheduling'
};

const parseModuleList = (value = '') => (
  `${value}`
    .split(',')
    .map((moduleId) => moduleId.trim().toLowerCase())
    .filter(Boolean)
);

const explicitlyEnabledModules = parseModuleList(process.env.REACT_APP_ENABLED_MODULES);
const explicitlyDisabledModules = parseModuleList(process.env.REACT_APP_DISABLED_MODULES);

export const isModuleEnabled = (moduleId) => {
  const normalizedModuleId = `${moduleId || ''}`.trim().toLowerCase();
  if (!normalizedModuleId) {
    return false;
  }

  if (explicitlyDisabledModules.includes(normalizedModuleId)) {
    return false;
  }

  if (explicitlyEnabledModules.length === 0 || explicitlyEnabledModules.includes('all')) {
    return true;
  }

  return explicitlyEnabledModules.includes(normalizedModuleId);
};

export const getEnabledModuleIds = (moduleIds = []) => (
  moduleIds.filter((moduleId) => isModuleEnabled(moduleId))
);

